export default __webpack_public_path__ + "static/media/envelopemanila.80c14b1e.png";